"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _iconBase = _interopRequireDefault(require("@kbbcomponentlibrary/icon-base"));

/*eslint import/namespace: ['error', { allowComputed: true }]*/
var IconPhone = function IconPhone(props) {
  return _react["default"].createElement(_iconBase["default"], props, _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M466.5,378.2c0,5.4-1,12.4-3,21s-4.1,15.5-6.3,20.4c-4.2,9.9-16.3,20.5-36.4,31.6c-18.7,10.1-37.2,15.2-55.5,15.2 c-5.4,0-10.6-0.3-15.7-1c-5.1-0.7-10.8-1.9-17.2-3.7c-6.4-1.8-11.1-3.2-14.2-4.3c-3.1-1.1-8.6-3.1-16.6-6.1s-12.8-4.8-14.6-5.4 c-19.5-7-36.9-15.2-52.2-24.8c-25.5-15.7-51.8-37.1-78.9-64.3c-27.1-27.1-48.6-53.4-64.3-78.9c-9.5-15.3-17.8-32.7-24.8-52.2 c-0.6-1.8-2.4-6.7-5.4-14.6c-3-8-5-13.5-6.1-16.6c-1.1-3.1-2.5-7.8-4.3-14.2c-1.8-6.4-3-12.1-3.7-17.2c-0.7-5.1-1-10.3-1-15.7 c0-18.3,5.1-36.8,15.2-55.5C72.8,72,83.4,59.9,93.3,55.7c5-2.2,11.8-4.3,20.4-6.3s15.7-3,21-3c2.8,0,4.9,0.3,6.3,0.9 c3.6,1.2,8.8,8.8,15.8,22.7c2.2,3.8,5.2,9.1,8.9,16.1c3.8,7,7.3,13.3,10.4,18.9c3.2,5.7,6.3,11,9.2,16c0.6,0.8,2.3,3.3,5.2,7.5 c2.9,4.2,5,7.7,6.4,10.6c1.4,2.9,2.1,5.7,2.1,8.5c0,4-2.8,8.9-8.5,14.9s-11.8,11.4-18.5,16.4c-6.7,5-12.8,10.2-18.5,15.8 c-5.7,5.6-8.5,10.1-8.5,13.7c0,1.8,0.5,4,1.5,6.7c1,2.7,1.8,4.7,2.5,6.1c0.7,1.4,2.1,3.8,4.2,7.2c2.1,3.4,3.2,5.3,3.4,5.7 c15.1,27.2,32.4,50.6,51.9,70.1c19.5,19.5,42.9,36.8,70.1,51.9c0.4,0.2,2.3,1.3,5.7,3.4s5.8,3.5,7.2,4.2c1.4,0.7,3.4,1.5,6.1,2.5 c2.7,1,4.9,1.5,6.7,1.5c3.6,0,8.2-2.8,13.7-8.5c5.6-5.7,10.8-11.8,15.8-18.5c5-6.7,10.4-12.8,16.4-18.5c6-5.7,10.9-8.5,14.9-8.5 c2.8,0,5.6,0.7,8.5,2.1c2.9,1.4,6.4,3.5,10.6,6.4s6.7,4.6,7.5,5.2c5,3,10.3,6.1,16,9.2c5.7,3.2,12,6.7,18.9,10.4 c7,3.8,12.3,6.8,16.1,8.9c13.9,7,21.5,12.2,22.7,15.8C466.2,373.3,466.5,375.4,466.5,378.2z"
  })));
};

IconPhone.displayName = 'IconPhone';
var _default = IconPhone;
exports["default"] = _default;
IconPhone.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "IconPhone",
  "props": {
    "size": {
      "required": true,
      "flowType": {
        "name": "number"
      },
      "description": ""
    },
    "viewBox": {
      "required": true,
      "flowType": {
        "name": "string"
      },
      "description": ""
    },
    "colorFill": {
      "required": true,
      "flowType": {
        "name": "string"
      },
      "description": ""
    },
    "children": {
      "required": false,
      "flowType": {
        "name": "ReactElement",
        "raw": "React.Element<*>",
        "elements": [{
          "name": "unknown"
        }]
      },
      "description": ""
    }
  }
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Phone.js"] = {
    name: "IconPhone",
    docgenInfo: IconPhone.__docgenInfo,
    path: "src/Phone.js"
  };
}